import appLocaleData from 'react-intl/locale-data/de';
import saMessages from '../locales/de_DE';

const saLang = {
    messages: {
        ...saMessages
    },
    locale: 'de-DE',
    data: appLocaleData
};
export default saLang;